import React from 'react';
import { URLS } from '../urls';
import moment from 'moment';
import DatePicker from 'react-datetime';
import { Form, Col, Row, Image } from 'react-bootstrap';
export default class EditLeaveModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            buttonText : 'Submit',
            isWaiting : false,
            editLeave : {
                employee : {
                    id : null,
                    name : '',
                    image : '',
                    designation : ''
                },
                name : '',
                from : moment(new Date()).format("DD/MM/YYYY"),
                to : moment(new Date()).format("DD/MM/YYYY"),
                days : 1,
                remaining : 0,
                reason : '',
                status : 'New',
                appliedDate : ''
            },
            leaveTypes : []
        };
    }
    componentWillReceiveProps(props){
        if(props.leaveTypes.length)
            this.setState({
                leaveTypes : props.leaveTypes
            })
        if(props.editLeave)
            this.setState({
                editLeave : props.editLeave
            })
    }
    updateLeaveName = (e) =>{
        const{editLeave} = this.state;
        editLeave.name = e.target.value;
        this.setState({
            editLeave
        })
    }
    updateLeaveFrom = (event) => {
		const {editLeave} = this.state;
		editLeave.from= event.target ? event.target.value : moment(event).format("DD/MM/YYYY");
		this.setState({
			editLeave
		})
    }
    updateLeaveTo = (event) => {
		const {editLeave} = this.state;
        editLeave.to= event.target ? event.target.value : moment(event).format("DD/MM/YYYY");
        editLeave.days = moment(editLeave.to,"DD/MM/YYYY").diff(moment(editLeave.from,"DD/MM/YYYY"),'days')+1;
		this.setState({
			editLeave
		})
	}
    updateLeaveDays = (e) =>{
        const{editLeave} = this.state;
        editLeave.days = e.target.value;
        this.setState({
            editLeave
        })
    }
    updateLeaveRemaining = (e) =>{
        const{editLeave} = this.state;
        editLeave.remaining = e.target.value;
        this.setState({
            editLeave
        })
    }
    updateLeaveReason = (e) =>{
        const{editLeave} = this.state;
        editLeave.reason = e.target.value;
        this.setState({
            editLeave
        })
    }
    
    submit = (e) => {
        e.preventDefault();
        this.setState({buttonText:'Submitting ...',isWaiting:true})
        const { editLeave } = this.state;
        const token = 'dummy token'; 
        fetch(`${URLS.backendApplyLeaves}/update`, {
            method: 'POST',
            headers: {
                'Content-Type' : 'application/json',
                'Authorization' : `Token ${token}`
            },
            body: JSON.stringify({applyLeave : editLeave}),
        }).then(res =>{
            if(res.ok){
                res.json().then((result) => {
                    console.log(result);
                    setTimeout(()=>{
                        window.$("#edit_leave").modal("toggle");
                        this.setState({ buttonText: 'Submit', isWaiting: false });
                        this.props.updateAppliedLeavesList(result.applyLeave);
                    }, 500);
                });
            }else{
                res.json().then((responseJson) => {
                    console.log(responseJson);
                    alert("Error occurred, Check the form again.");
                    this.setState({ buttonText: 'Submit', isWaiting: false });
                });
            }
        });
    };

	render() {
        const {editLeave,leaveTypes,buttonText} = this.state;
        return (
            <div id="edit_leave" className="modal custom-modal fade" role="dialog">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">Add Leave</h5>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <form onSubmit={this.submit}>
                                <div className="form-group">
                                    <label>Leave Type <span className="text-danger">*</span></label>
                                    <Form.Control as='select' value={editLeave.name}
                                        onChange={this.updateLeaveName} style={{height:'35px'}}>
                                        <option value=''>Select Type</option>
                                        {
                                            leaveTypes.length ? leaveTypes.map(leaveType =>{
                                                return(
                                                    <option value={leaveType.name}>{leaveType.name}</option>
                                                )
                                            }) : ''
                                        }
                                    </Form.Control>
                                </div>
                                <div className="form-group">
                                    <label>From <span className="text-danger">*</span></label>
                                    <div className="cal-icon">
                                        <DatePicker 
                                            value={editLeave.from} 
                                            closeOnSelect={true}
                                            onChange={this.updateLeaveFrom}
                                            required={true}/>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label>To <span className="text-danger">*</span></label>
                                    <div className="cal-icon">
                                        <DatePicker 
                                            value={editLeave.to} 
                                            closeOnSelect={true}
                                            onChange={this.updateLeaveTo}
                                            required={true}/>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <label>Number of days <span className="text-danger">*</span></label>
                                    <input className="form-control" readonly type="number"  value={editLeave.days}/>
                                </div>
                                <div className="form-group">
                                    <label>Remaining Leaves <span className="text-danger">*</span></label>
                                    <input className="form-control" readonly type="number" value={editLeave.remaining}/>
                                </div>
                                <div className="form-group">
                                    <label>Leave Reason <span className="text-danger">*</span></label>
                                    <textarea rows="4" className="form-control" value={editLeave.reason} onChange={this.updateLeaveReason}></textarea>
                                </div>
                                <div className="submit-section">
                                    <button className="btn btn-primary submit-btn">{buttonText}</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}